import {
	SAVE_OPENID,
	
} from './mutation-types.js'

export default {
	
	[SAVE_OPENID](state,openId){
		state.openId=openId;
	}
	
}


// WEBPACK FOOTER //
// ./src/store/mutations.js